module.exports = __webpack_public_path__ + "img/1inch.720e70f7.svg";